import { render, staticRenderFns } from "./UserNearby.vue?vue&type=template&id=acc115d4"
import script from "./UserNearby.vue?vue&type=script&lang=ts"
export * from "./UserNearby.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports